import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app


import Image from '../../atoms/Image';
import { ImageContainer, LightboxContainer, StyledIconBox, StyledTypography } from './style';
// import zIndex from '@material-ui/core/styles/zIndex';

const ImageLightbox = ({ images, thmubsSize, searchIcon }) => {
  const [isOpen, setOpen] = useState(false);
  const [imageIndex, setIndex] = useState(0);
  const [imagesPreview, setImagesPreview] = useState()

  useEffect(() => {
    setImagesPreview(images.slice(0, 6));

  },[])

  return (
    <LightboxContainer>
      {imagesPreview &&
        imagesPreview.map((img, index) => (
          <ImageContainer key={img}>
            <Image
             
              fitCover
              onClick={() => {
                setIndex(index);
                setOpen(true);
              }}
              src={img}
            />
            {index === 5 && (
              <StyledTypography
                onClick={() => {
                  setIndex(index);
                  setOpen(true);
                }}
                variant="h4"
              >
                +{images.length - 6}
              </StyledTypography>
            )}
            <StyledIconBox>{searchIcon}</StyledIconBox>
          </ImageContainer>
        ))}

      {isOpen && (
        <Lightbox
          mainSrc={images[imageIndex]}
          nextSrc={images[(imageIndex + 1) % images.length]}
          prevSrc={images[(imageIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setOpen(false)}
          onMovePrevRequest={() => setIndex((imageIndex + images.length - 1) % images.length)}
          onMoveNextRequest={() => setIndex((imageIndex + 1) % images.length)}
          reactModalStyle={{
            overlay: {
              zIndex: 1200,
            },
          }}
        />
      )}
    </LightboxContainer>
  );
};

ImageLightbox.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  thmubsSize: PropTypes.string,
  searchIcon: PropTypes.node
};

ImageLightbox.defaultProps = {
  thmubsSize: '200px',
  searchIcon: null
};

export default ImageLightbox;
